export default __webpack_public_path__ + "static/media/russian poker-12.9d3b0155.png";